import { Component, Inject, OnInit, EventEmitter } from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { ComponentFactoryService } from '../../../../../../services/component-factory.service';
import { BeneficiosIngresosNoGravados } from '../../beneficios-tributarios/beneficios-ingresos-no-gravados-modal/beneficios-ingresos-no-gravados-modal.component';
import { IngresostrabajadorindependienteModalComponent } from '../../ingresos/ingresos-trabajador-independiente-modal/ingresos-trabajador-independiente-modal.component';
import { IngresosAsalariadooServidorpublicoModalComponent } from '../../ingresos/ingresos-asalariado-o-servidor-publico-modal/ingresos-asalariado-o-servidor-publico-modal.component';
import { SugeridaSingletonService } from '../../../../../../services/sugerida.service';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE='cs_id_229';

declare var require: (filename: string) => any;
var BigNumber210 = require('bignumber.js');

BigNumber210.config({
  DECIMAL_PLACES: 3,
  EXPONENTIAL_AT: 100,
  FORMAT: {
    groupSize: 3,
    groupSeparator: ',',
    decimalSeparator: '.'
  }
});

const stepsList = [
  { text: "1", active: true, completed: false, tooltip: 'Lista de rentas exentas sin limitantes de ley', listHelp: ['757'] }
];

const tableStructure = [
    {id: 'origen', title: 'Origen Información' },
    {id: 'conceptoNombre', title: 'Concepto'}, 
    {id: 'tipoRentaNombre', title: 'Tipo de Renta'}, 
    {id: 'valor', title: 'Valor'},
];


class Form1 {
  id: number;
  conceptoNombre:string;
  tipoRentaNombre:string;
  valor:string;
  concepto:string;
  tipoRenta:string;
  origen: string;
  reportante:string;
}

class ValoresDominio {
  valor: string;
  nombre: string;
  mostrar: boolean;
}

@Component({
  selector: 'app-beneficios-rentas-exentas-sin-limite-modal',
  templateUrl: './beneficios-rentas-exentas-sin-limite-modal.component.html',
  styleUrls: ['./beneficios-rentas-exentas-sin-limite-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio,
    ComponentFactoryService
  ]
})
export class BeneficiosRentasExentasSinLimiteModalComponent extends HandlerModal implements OnInit {

  public dataSourceHeader = tableStructure;
  public dataSourceBody = [];
  public modelForm: Form1 = new Form1();
  public listaPorc: number[] = [];

  public OPERACION_NULA:number = 0;
  public OPERACION_AGREGAR:number = 1;
  public OPERACION_EDITAR:number = 2;
  public OPERACION_BORRAR:number = 3; 
  public operacionTabla:number = this.OPERACION_NULA;
  casillaLimpiada: boolean = false;

  saveModel = new EventEmitter();
  public showSave:boolean;
  model:DDocumento;
  mensajeTabla = "Algunos campos fueron sugeridos por el sistema(basados en su información exógena). Edite, agregue o elimine ítems de ser necesario.";
  mensajeForm = "Este ítem fue sugerido con base a su información exógena. Al editarlo no esta editando su exógena, simplemente no será usada para este ítem.";
  
  listaConcpRentaExenSinLimite: any;
  listaTipoRentaExenSinLimite: any;

  constructor(
    public dutilidades:DOperacionesMatematicasServicio, 
    public dNotificacionServicio: DNotificacionServicio,
    private _componentFactory: ComponentFactoryService,
    public dialogRef: MatDialogRef<BeneficiosRentasExentasSinLimiteModalComponent>,
    private _sugeridaSingletonService: SugeridaSingletonService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    this.model = this.data.model;
    //console.log(this.model);
  }

  ngOnInit() {
    this.inicializeModelo();
    this.inicializeForm();
    this.initializeTablaDesdeModelo();
    this.initializeTablaDesdeSugerida();
    this.validateShowSave();
    
    this.listaTipoRentaExenSinLimite = this.listaTipoRentaExenSinLimite.map((item: any) => ({...item, mostrar: true }));

    //console.log(this.listaTipoRentaExenSinLimite);
    
    //console.log(this.model);

  }

  limpiarValor() {
    if (this.modelForm.valor === '0' && !this.casillaLimpiada) {
      this.modelForm.valor = null;
      this.casillaLimpiada = true;
    }
  }
  
  protected controlStep(direction: DirectionType): void {
  
  }
  

  protected inicializeForm(){
    this.modelForm = new Form1();
    this.modelForm.id=0;
    this.modelForm.valor="0";
    this.modelForm.conceptoNombre="";
    this.modelForm.concepto="0"
    this.modelForm.tipoRentaNombre="";
    this.modelForm.tipoRenta="0";
  
    this.modelForm.origen = "";
    this.modelForm.reportante="";
}
  
  protected inicializeModelo(){
    if(this.model.doc.cuerpo.cc_id_760 == undefined){

      this.model.doc.cuerpo.cc_id_760 = []; //concepto
      this.model.doc.cuerpo.cc_id_761 = []; //tipoRenta
      this.model.doc.cuerpo.cc_id_762 = []; //valor
      this.model.doc.cuerpo.cc_id_759 = []; //origen
      this.model.doc.cuerpo.cs_id_763 = "0";
   
    }  
  }

  public operacionCs763(){ 
    let suma = "0";
    for(let i=0; i<this.dataSourceBody.length; i++){

        suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.dataSourceBody[i].valor, suma);
    
    }
    if(suma)
    this.model.doc.cuerpo.cs_id_763 = suma;
    else
    this.model.doc.cuerpo.cs_id_763 = '0';
  }

  //Método que muestra o no items en la lista de listaTipoRentaExenSinLimite
  protected reloadSelConcepto(){
    
    if(this.modelForm.concepto == "1" || this.modelForm.concepto == "2" || this.modelForm.concepto == "3" ||
       this.modelForm.concepto == "4" || this.modelForm.concepto == "5" || this.modelForm.concepto == "6" ||
       this.modelForm.concepto == "7" || this.modelForm.concepto == "8" || this.modelForm.concepto == "9"
    ){
      
      for (let i = 0; i < this.listaTipoRentaExenSinLimite.length; i++) {
        if (i == 0) {
          this.listaTipoRentaExenSinLimite[i].mostrar = true;
        }else{
          this.listaTipoRentaExenSinLimite[i].mostrar = false;
        }

      }
    }else if(this.modelForm.concepto == "10"){
      for (let i = 0; i < this.listaTipoRentaExenSinLimite.length; i++) {
        if (i == 3) {
          this.listaTipoRentaExenSinLimite[i].mostrar = true;
        }else{
          this.listaTipoRentaExenSinLimite[i].mostrar = false;
        }

      }
    }else if(this.modelForm.concepto == "11"){
      for (let i = 0; i < this.listaTipoRentaExenSinLimite.length; i++) {
        
        this.listaTipoRentaExenSinLimite[i].mostrar = true;

      }
    }

  }

  //////////////////////

  protected initializeTablaDesdeModelo(){
    this.dataSourceBody = [];
    //for(let i=0; i<this.model.doc.cuerpo.cc_id_760.length; i++){
    for(let i=0; i<this.model.doc.cuerpo.cc_id_762.length; i++){
      this.modelForm.id=i;
      this.modelForm.concepto=this.model.doc.cuerpo.cc_id_760[i].v;
      if(this.listaConcpRentaExenSinLimite && this.listaConcpRentaExenSinLimite.length>0)
        this.modelForm.conceptoNombre = this.listaConcpRentaExenSinLimite.find((elemento: { valor: any; }) => elemento.valor === this.model.doc.cuerpo.cc_id_760[i].v).nombre;
      this.modelForm.tipoRenta=this.model.doc.cuerpo.cc_id_761[i].v;
      if(this.listaTipoRentaExenSinLimite && this.listaTipoRentaExenSinLimite.length>0)
        this.modelForm.tipoRentaNombre = this.listaTipoRentaExenSinLimite.find((elemento: { valor: any; }) => elemento.valor === this.model.doc.cuerpo.cc_id_761[i].v).nombre;
      this.modelForm.valor=this.model.doc.cuerpo.cc_id_762[i].v;
      
      this.modelForm.origen = this.model.doc.cuerpo.cc_id_759[i].v;

      this.dataSourceBody.push(this.modelForm);
      this.inicializeForm();
    }
    this.operacionCs763();
  }
  protected initializeTablaDesdeSugerida() {

    let indexModel = this.model.doc.cuerpo.cc_id_760.length;

    if (indexModel == 0) {

      const fieldsRecovery = ['VAR_7412'];
      const resData = this._sugeridaSingletonService.getDataArrFromMap(fieldsRecovery);
      console.log(resData);

      if (resData) {

        for (let i = 0; i < resData.length; i++) {
          for (let j = 0; j < resData[i].item.value.length; j++) {

            this.modelForm.id = indexModel;
            this.modelForm.valor = String(resData[i].item.value[j]);
            this.modelForm.concepto = "9";
            if(this.listaConcpRentaExenSinLimite && this.listaConcpRentaExenSinLimite.find((elemento: { valor: any; }) => elemento.valor === this.modelForm.concepto))
              this.modelForm.conceptoNombre = this.listaConcpRentaExenSinLimite.find((elemento: { valor: any; }) => elemento.valor === this.modelForm.concepto).nombre;
            this.modelForm.tipoRenta = "1";
            if(this.listaTipoRentaExenSinLimite && this.listaTipoRentaExenSinLimite.find((elemento: { valor: any; }) => elemento.valor === this.modelForm.tipoRenta))
              this.modelForm.tipoRentaNombre = this.listaTipoRentaExenSinLimite.find((elemento: { valor: any; }) => elemento.valor === this.modelForm.tipoRenta).nombre;
            this.modelForm.origen = "0";
            this.redondearFormData();
            this.dataSourceBody.push(this.modelForm);
            this.inicializeForm();
            indexModel++;
          }
        }
      }
    }
    this.operacionCs763();
  }

  public editModeloDesdeForm(){
   
    this.model.doc.cuerpo.cc_id_760[this.modelForm.id].v=this.modelForm.concepto.toString();
    this.model.doc.cuerpo.cc_id_761[this.modelForm.id].v=this.modelForm.tipoRenta.toString();
    this.model.doc.cuerpo.cc_id_762[this.modelForm.id].v=this.modelForm.valor.toString();
    this.model.doc.cuerpo.cc_id_759[this.modelForm.id].v = this.modelForm.origen;

    this.operacionCs763();
  
  }

  public addToModeloDesdeForm(){
    let i= this.modelForm.id+1;
    
    this.model.doc.cuerpo.cc_id_760.push({it: i, v:this.modelForm.concepto.toString()});
    this.model.doc.cuerpo.cc_id_761.push({it: i, v:this.modelForm.tipoRenta.toString()});
    this.model.doc.cuerpo.cc_id_762.push({it: i, v:this.modelForm.valor.toString()});
    this.model.doc.cuerpo.cc_id_759.push({ it: i, v: this.modelForm.origen });
    
    this.operacionCs763();
  }

  public deleteOnModel(index:number){
    this.model.doc.cuerpo.cc_id_760.splice(index,1);
    this.model.doc.cuerpo.cc_id_761.splice(index,1);
    this.model.doc.cuerpo.cc_id_762.splice(index,1);
    this.model.doc.cuerpo.cc_id_759.splice(index, 1);
    
    //reenumerear it
    for(let i=0;i<this.model.doc.cuerpo.cc_id_760.length;i++){
      this.model.doc.cuerpo.cc_id_760[i].it=i+1;
      this.model.doc.cuerpo.cc_id_761[i].it=i+1;
      this.model.doc.cuerpo.cc_id_762[i].it=i+1;
      this.model.doc.cuerpo.cc_id_759[i].it=i+1;
    }
    this.operacionCs763();
  }

  public validateFormCompleted():boolean{
    return this.modelForm.concepto==undefined || this.modelForm.concepto==null || this.modelForm.concepto.trim()=="" ||
        this.modelForm.valor==undefined || this.modelForm.valor == "0" || this.modelForm.tipoRenta==undefined || this.modelForm.tipoRenta.trim()==""
  }

  public redondearFormData(){
    this.modelForm.valor=this.dutilidades.redondearValorMoneda(this.modelForm.valor.toString(),true);
    
  }

  saveItem(): void {
    if(this.validateFormCompleted()){
      let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro" );
      return;
    }else{
      this.redondearFormData();
        if (this.operacionTabla==this.OPERACION_EDITAR){
          
        
          this.modelForm.conceptoNombre = this.listaConcpRentaExenSinLimite.find((elemento: { valor: any; }) => elemento.valor === this.modelForm.concepto).nombre;
          this.modelForm.tipoRentaNombre = this.listaTipoRentaExenSinLimite.find((elemento: { valor: any; }) => elemento.valor === this.modelForm.tipoRenta).nombre;

          
          if(this.modelForm.origen=="0"){ 
            this.modelForm.origen = "1";
          }
          this.dataSourceBody.forEach((el)=>{
            if(el.id == this.modelForm.id){
              el=this.modelForm;
            }
          });

       }else if (this.operacionTabla==this.OPERACION_AGREGAR){ 
        this.modelForm.id = this.model.doc.cuerpo.cc_id_760.length;
        this.modelForm.origen = "2";
        this.modelForm.conceptoNombre = this.listaConcpRentaExenSinLimite.find((elemento: { valor: any; }) => elemento.valor === this.modelForm.concepto).nombre;
        this.modelForm.tipoRentaNombre = this.listaTipoRentaExenSinLimite.find((elemento: { valor: any; }) => elemento.valor === this.modelForm.tipoRenta).nombre;
        this.dataSourceBody.push(this.modelForm);

      }
      //Recalcular y reinicializar
      this.operacionCs763();
      this.inicializeForm();
      this.operacionTabla=this.OPERACION_NULA;
    }
  }

  eventTable($event: string): void {
    if($event === 'add') this.operacionTabla=this.OPERACION_AGREGAR;
    if($event === 'edit') this.operacionTabla=this.OPERACION_EDITAR;
    if($event === 'delete') this.operacionTabla=this.OPERACION_BORRAR;
    this.operacionCs763();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if(this.operacionTabla==this.OPERACION_EDITAR){//editando
      this.modelForm = this.dataSourceBody[index];
      //this.reloadSelArticulos(true);
    }
    if(this.operacionTabla==this.OPERACION_BORRAR){//borrando
      //this.deleteOnModel(index);
      this.operacionTabla=this.OPERACION_NULA;
    }
  }
  
  cancel(): void {
    this.inicializeForm();
    this.operacionTabla=this.OPERACION_NULA;
  }

  

  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion:number): boolean{
    let hasValues:boolean = false;
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal:number){
    
  }
  
  
  protected obtenerCasIndicadorAvance():string{
    if(this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==undefined){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]="0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }

  protected validateShowSave(){
    if(this.indexStepper==this.stepsList.length-1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==VAL_INDICADOR_COMPLETO){ this.showSave=true };
  }

  public closeModal(){
    this.initializeTablaDesdeModelo();
    this.operacionCs763();
    this.dialogRef.close("");
  }
  
  public guardar(){
    //Limpiar modelo y agregar el contenido de la tabla
    //if(this.model.doc.cuerpo.cc_id_760.length != this.dataSourceBody.length){ 
      this.model.doc.cuerpo.cc_id_760 = undefined;
      this.inicializeModelo();  
      for(let i=0; i<this.dataSourceBody.length; i++){
        //const existeValor = this.model.doc.cuerpo.cc_id_760.some((item: { v: any; }) => item.v === this.dataSourceBody[i].concepto);
         
        //if(!existeValor){
          this.modelForm = this.dataSourceBody[i];
          this.addToModeloDesdeForm(); 

         }
        
       
      //}
    //}

    this.operacionCs763();
    
    this.saveModel.emit(true); 
    //console.log(this.model.doc.cuerpo);

    this.closeModal();

  }
  
  public borrarTabla(){
    this.dataSourceBody = [];
  }


}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/beneficios-tributarios/beneficios-rentas-exentas-sin-limite-modal/beneficios-rentas-exentas-sin-limite-modal.component.ts